/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import { customStyle } from 'helper';
import DateRangePickerFilter from 'modules/common/components/DateRangePickerFilter';
import Loading from 'modules/common/components/Loading';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';

const colors = ['#5272AA', '#7790CB', '#8AA4F8', '#A3B3F9'];

const optionList = [
  { label: 'INDIVIDUAL', value: 'INDIVIDUAL' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];

const payload = {
  period: 'DAILY',
  date_from: moment().subtract(1, 'M').format('YYYY-MM-DD'),
  date_to: moment().format('YYYY-MM-DD'),
};

const rename = (obj, oldKey, newKey) => {
  if (_.has(obj, oldKey)) {
    _.set(obj, newKey, _.get(obj, oldKey));
    _.unset(obj, oldKey);
  }
  return obj;
};

const filter = {
  transaction_type: 'ALL',
};

function DashboardChartMapContainer({
  createDynamicAreaChart,
  transactionList,
  graphStats,
  getGraphStats,
}) {
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  const handleOnSubmit = ({ type, from, to }) => {
    getGraphStats({
      period: type,
      date_from: from,
      date_to: to,
      module_type: 'T_BPLS',
      permit_type: 'Business Permit Application (NEW & RENEWAL)',
    });
  };

  const handleChangeSelect = (e) => {
    setFilterData({
      ...filterData,
      transaction_type: e ? e.value : '',
    });
  };

  const formatKey = [
    {
      key: 'INDIVIDUAL',
      color: `${colors[0]}`,
    },
    {
      key: 'CORPORATION',
      color: `${colors[1]}`,
    },
  ];

  useEffect(() => {
    getGraphStats(payload);
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="col-12">
          <DateRangePickerFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          {createDynamicAreaChart(
            graphStats.values,
            graphStats.labels,
            {
              xAxisProps: {
                fontSize: '10px',
                angle: -35,
                scale: 'point',
              },
              yAxisProps: {
                angle: -55,
              },
              composeOption: {
                bottom: 20,
              },
            },
            isLoading
          )}
        </div>
      </div>
    </div>
  );
}

DashboardChartMapContainer.propTypes = {
  createDynamicAreaChart: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  graphStats: PropTypes.instanceOf(Object).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

const formatGraphData = (data) => {
  const labels = [];
  const values = [];

  data.forEach((item, i) => {
    const entries = Object.entries(item).filter(
      (a) => ['name', 'included', 'RPT', 'BPLS'].indexOf(a[0]) < 0
    );

    if (i === 0) {
      entries.forEach((entry, x) => {
        labels[x] = {
          key: entry[0],
          color: colors[x],
        };
      });
    }

    values[i] = rename(
      rename(
        rename(item, 'OHP', 'Occupational / Health Permits'),
        'CDL',
        'Community Tax CertificateCTC / CEDULA'
      ),
      'PSA',
      'Civil Registry Office'
    );
  });

  return {
    labels,
    values,
  };
};

const mapStateToProps = ({ api }) => ({
  graphStats: formatGraphData(_.get(api, `${c.GET_GRAPH_STATS}.list`) || []),
  transactionList: [
    {
      INDIVIDUAL: 812,
      CORPORATION: 340,
      name: 'JAN',
    },
    {
      INDIVIDUAL: 512,
      CORPORATION: 121,
      name: 'FEB',
    },
  ],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(DashboardChartMapContainer);
